import { render, staticRenderFns } from "./farmingNewMap.vue?vue&type=template&id=0298cbcc&scoped=true"
import script from "./farmingNewMap.vue?vue&type=script&lang=js"
export * from "./farmingNewMap.vue?vue&type=script&lang=js"
import style0 from "./farmingNewMap.vue?vue&type=style&index=0&id=0298cbcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298cbcc",
  null
  
)

export default component.exports